// extracted by mini-css-extract-plugin
export default {"row":"NumerationScreen_row__CycEc","alignCenter":"NumerationScreen_alignCenter__wl3hO"};